import { HeaderControls, HeaderModule } from 'components/header/anand.header';
import { Records } from 'core/anand.records';
import { addFormHTML, briefTileHTML, detailFormHTML, detailTileHTML } from './viewTile';

export const RecordsHandler = (function ($) {
	var configMap = {};

	var stateMap: any = {
		systemId: 'category',
	};

	function initModule(props?, updateRecordsState?) {
		HeaderModule.initModule([
			HeaderControls.addRecordBtn,
			HeaderControls.selectDropdown,
			HeaderControls.printBtn,
			HeaderControls.sortBtn,
		]);

		Records.projectTitle = 'Amar Satya Sandesh Categories';

		Records.getAnySearchFilter = getAnySearchFilter;
		Records.defaultSortOrder = 'name';
		Records.IdentifyingFieldName = 'code';

		Records.sortingFieldsMap = {
			name: 'Name',
			code: 'Code',
		};

		Records.searchFieldsMap = {
			name: 'Name',
			code: 'Code',
		};

		Records.isSearchDateTypeColumn = function (searchBy) {
			return false;
		};

		Records.printOptions = {
			fieldNames: ['S. No.', 'Name', 'Code', 'Issues', 'Period'],
			fieldKeys: ['id', 'name', 'code', 'issues_count', 'period'],
			defaultFieldWidths: { id: 50, name: 150, code: 150, issues_count: 100, period: 100 },
			defaultHeader: 'Amar Satya Sandesh Category Records',
			beforePrintHook: function (data, forExport) {
				for (var i = 0; i < data.length; i++) {
					data[i]['id'] = i + 1 + '.';
				}

				return data;
			},
		};

		Records.exportOptions = {
			fieldKeys: ['id', 'name', 'code', 'issues_count', 'period'],
			defaultFileName: 'Amar Satya Sandesh Category Records',
		};

		Records.hooks.afterHeaderConfigure = function (controlsHeader) {
			controlsHeader.find('.reminder-btn').hide();
			controlsHeader.find('.dashboard-btn').hide();
		};

		Records.detailTileSelector = '#amar-category-detail-record';
		Records.briefTileSelector = '#amar-category-brief-record';
		Records.addTileSelector = '#amar-category-add-record';
		Records.detailFormSelector = '#amar-category-detail-record-form';
		Records.imageUploadSelector = null;

		Records.detailTileHTML = detailTileHTML;
		Records.briefTileHTML = briefTileHTML;
		Records.detailFormHTML = detailFormHTML;
		Records.addFormHTML = addFormHTML;

		Records.populateBriefTile = populateBriefTile;
		Records.populateDetailTile = populateDetailTile;
		Records.populateDetailForm = populateDetailForm;

		Records.updateRecordsState = updateRecordsState;

		Records.initModule({ systemId: stateMap.systemId, prepareRecord: prepareRecord, props: props });
	}

	function prepareRecord(record) {
		return record;
	}

	function getAnySearchFilter(query) {
		return [{ name: { likenocase: query } }, { code: { leftnocase: query } }];
	}

	async function populateBriefTile(sampleTile, record) {
		sampleTile.find('.name-detail .value').html(record['name']);
		sampleTile.find('.code-detail .value').html(record['code']);
		sampleTile.find('.issues-detail .value').html(record['issues_count']);
		sampleTile.find('.period-detail .value').html(record['period']);

		return sampleTile;
	}

	async function populateDetailTile(sampleTile, recordOrig) {
		var record = {};
		for (var key in recordOrig) {
			if (recordOrig[key] == null || recordOrig[key] == '') {
				record[key] = '&nbsp';
			} else {
				record[key] = recordOrig[key];
			}
		}

		sampleTile.find('.name-detail .value').html(record['name']);
		sampleTile.find('.code-detail .value').html(record['code']);
		sampleTile.find('.issues-detail .value').html(record['issues_count']);
		sampleTile.find('.period-detail .value').html(record['period']);

		return sampleTile;
	}

	function populateDetailForm(sampleTile, record) {
		sampleTile.find('.name-detail .value input').val(record['name']);
		sampleTile.find('.code-detail .value input').val(record['code']);
		sampleTile.find('.issues-detail .value input').val(record['issues_count']);
		sampleTile.find('.period-detail .value input').val(record['period']);

		return sampleTile;
	}

	return {
		initModule: initModule,
		setConfig: function (key, value) {
			configMap[key] = value;
		},
	};
})(jQuery);
